/* eslint object-curly-newline:0 */
/* eslint no-plusplus:0 */
import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import { ParkingLotsApi, ParkingEventsApi } from '../../api';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    overview: {
      workload: 0,
      stream: [],
      lineChart: {
        labels: [],
        datasets: [],
      },
    },
    detailed: {
      workloads: {
        eparking: 0,
        handicapped: 0,
        withRules: 0,
        normal: 0,
      },
      statistics: {
        averageWorkload: 0,
        averageRotations: 0,
        averageParkDuration: '',
        exceededParkings: 0,
      },
    },
    currentUsage: null,
    dailyStats: null,
  },
  mutations: {
    ADD_STREAM_ENTRY(state, entry) {
      state.overview.stream.unshift(entry);
    },
    SET_STREAM_DATA(state, data) {
      state.overview.stream = data;
    },
    SET_DAILY_STATS_DATA(state, data) {
      state.dailyStats = data;
      state.detailed.statistics.averageParkDuration = data.avg_duration.secs;
    },
    SET_WORKLOAD(state, data) {
      var timestamps = data.timestamps.map(a => moment.utc(a));
      // Replace the first element (beginning of the day) by moment as the
      // one generated by the server would not be correct as of server time. (meh)
      timestamps[0] = moment().startOf('day')

      state.overview.lineChart.datasets = data.workloads;
      state.overview.lineChart.labels = timestamps;
    },
    SET_DAILY_CURRENT_USAGE_DATA(state, data) {
      state.currentUsage = data;
      state.overview.workload = data.overall.workload;
    },
  },
  actions: {
    GET_CURRENT_USAGE({ commit }) {
      ParkingLotsApi.getCurrentUsage()
        .then((resp) => {
          commit('SET_DAILY_CURRENT_USAGE_DATA', resp.data);
        });
    },
    GET_DAILY_STATS({ commit }) {
      ParkingLotsApi.getDailyStats()
        .then((resp) => {
          commit('SET_DAILY_STATS_DATA', resp.data);
        });
    },
    GET_WORKLOAD({ commit }) {
      ParkingLotsApi.getWorkload()
        .then((resp) => {
          commit('SET_WORKLOAD', resp.data);
        });
    },
    GET_LATEST_EVENTS({ commit, dispatch }) {
      ParkingEventsApi.getEvents({today: "true"})
        .then((resp) => {
          const events = resp.data.map(event => {
            return {
              id: event.id,
              meta: 'parking_space_changed',
              newVal: event.event_type === 'free',
              time: moment.utc(event.event_started).local().format('HH:mm'),
              date: moment.utc(event.event_started).local().format('YYYY-MM-DD'),
              parking_lot: {
                id: event.parking_lot.id,
                name: event.parking_lot.name,
              },
            };
          });
          commit('SET_STREAM_DATA', events);
        });
    },
    ADD_PARKING_EVENT({ commit }, payload) {
      if (['free', 'occupied'].includes(payload.event_type)) {
        const entry = {
          id: payload.id,
          meta: 'parking_space_changed',
          newVal: payload.event_type === 'free',
          time: moment.utc(payload.event_started).local().format('HH:mm'),
          date: moment.utc(payload.event_started).local().format('YYYY-MM-DD'),
          parking_lot: {
            id: payload.parking_lot.id,
            name: payload.parking_lot.name,
          },
        };
        commit('ADD_STREAM_ENTRY', entry);
      }
    },
  },
});
